import { lt, showSuccessAlert } from '@mews/framework';
import { FULL_BILL_EXTENT, deleteBill as deleteBillAction } from '@mews-commander/legacy-entities/src/actions/bills';
import { deleteBills, getBillOwnerId } from '@mews-commander/legacy-entities/src/ducks/bills';
import { refetchBill } from '../ducks/bills';
import {
    openCreateProforma as createProforma,
    openIssueInvoice as issueInvoice,
    openBillPreview as openPreview,
} from '../ducks/navigation';
import { logBillingAction } from '../utils/logBillingAction';
import { getRealBillId, moveItemsToTargetBill } from './utils';

export const openIssueInvoice =
    ({ billId, scope }: $TSFixMe) =>
    (dispatch: $TSFixMe) =>
        dispatch(getRealBillId({ billId, scope })).then((validBillId: $TSFixMe) => {
            dispatch(logBillingAction('Invoice modal opened'));
            return dispatch(issueInvoice({ billId: validBillId, scope }));
        });

export const openCreateProforma =
    ({ billId, scope }: $TSFixMe) =>
    (dispatch: $TSFixMe) =>
        dispatch(getRealBillId({ billId, scope })).then((validBillId: $TSFixMe) => {
            dispatch(logBillingAction('Proforma modal opened'));
            return dispatch(createProforma({ billId: validBillId, scope }));
        });

export const openBillPreview =
    ({ billId, scope }: $TSFixMe) =>
    (dispatch: $TSFixMe) =>
        dispatch(getRealBillId({ billId, scope })).then((validBillId: $TSFixMe) => {
            dispatch(logBillingAction('Bill preview modal opened'));
            return dispatch(openPreview({ billId: validBillId, scope }));
        });

export const deleteBill =
    ({ billId, scope }: $TSFixMe) =>
    (dispatch: $TSFixMe, getState: $TSFixMe) =>
        dispatch(getRealBillId({ billId, scope })).then((validBillId: $TSFixMe) => {
            dispatch(logBillingAction('Bill deleted'));
            return dispatch(deleteBillAction(validBillId))
                .then(() => {
                    showSuccessAlert({
                        description: lt('DeleteBillSuccessMessage'),
                    });
                })
                .catch((error: $TSFixMe) => {
                    const accountId = getBillOwnerId(getState(), { id: validBillId });

                    dispatch(deleteBills([validBillId]));
                    dispatch(refetchBill({ accountId, extent: FULL_BILL_EXTENT }));
                    throw error;
                });
        });

export const moveItemsToBill =
    ({ associatedAccountId, targetBillId, accountId, paymentIds, orderItemsIds, scope }: $TSFixMe) =>
    (dispatch: $TSFixMe) =>
        dispatch(getRealBillId({ billId: targetBillId, scope })).then((validBillId: $TSFixMe) =>
            dispatch(
                moveItemsToTargetBill({
                    targetBillId: validBillId,
                    ownerId: accountId,
                    paymentIds,
                    orderItemsIds,
                    associatedAccountId,
                })
            ).then(() => dispatch(refetchBill({ accountId, billId: validBillId, scope })))
        );
